var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackOverflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 480,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#607d8b",
    d: "M9 28h3v14H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#607d8b",
    d: "M9 39h26v3H9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#607d8b",
    d: "M32 28h3v14h-3zm-17 6h14v3H15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#a68a6e",
    d: "M15.08 28.26 29 29.758l-.32 2.982-13.92-1.498z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef6c00",
    d: "m36.87 6 2.134 13.835-2.966.458-2.133-13.836z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "m28.47 8.237 6.831 12.218-2.62 1.464-6.83-12.218z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d38b28",
    d: "m20.501 14.551 11.5 7.982-1.712 2.465-11.5-7.982z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#c09553",
    d: "m16.9 21.218 13.172 4.739-1.016 2.823-13.172-4.738z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackOverflow);
export default __webpack_public_path__ + "static/media/stack_overflow.aa057043270abf88cf20b16722a7b196.svg";
export { ForwardRef as ReactComponent };